export default __webpack_public_path__ + "static/media/gallery - story - other (1)_02.802043c1.jpg";